export const LOGIN_REQUEST = "LOGIN_REQUEST";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";

export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";

export const CHECK_TOKEN_LOGIN = "CHECK_TOKEN_LOGIN";

export const REGISTER_ACTION = "REGISTER_ACTION";

export const CREATE_NEW_PASSWORD_ACTION = "CREATE_NEW_PASSWORD_ACTION";

export const VALIDATE_PASSWORD_ACTION = "VALIDATE_PASSWORD_ACTION";

export const DELETE_ACCOUNT_ACTION = "DELETE_ACCOUNT_ACTION";

export const CANCEL_DELETE_ACCOUNT_ACTION = "CANCEL_DELETE_ACCOUNT_ACTION";

export const ON_LOGIN_WITH_FACE_ID_ACTION = "ON_LOGIN_WITH_FACE_ID_ACTION";

export const OFF_LOGIN_WITH_FACE_ID_ACTION = "OFF_LOGIN_WITH_FACE_ID_ACTION";

export const CHECK_REGISTER_DEVICE_ACTION = "CHECK_REGISTER_DEVICE_ACTION";

export const APPROVED_STATUS_DEVICE_ACTION = "APPROVED_STATUS_DEVICE_ACTION";
